<!--
 * @Description:
 * @Version: 1.0
 * @Autor: zsw
 * @Date: 2022-04-20 13:49:44
 * @LastEditors: 姚林刚
 * @LastEditTime: 2023-07-19 14:39:59
-->
<template>
  <div id="mapContainer" class="mapContainer">
    <div id="map" class="map"></div>
  </div>
</template>
<script>
import { TileSuperMapRest, LayerStatus, SetLayerStatusParameters, LayerInfoService } from "@supermap/iclient-ol";
import OlMap from "ol/Map";
import { Tile as TileLayer } from "ol/layer";
import {
  XYZ
}
from 'ol/source';
import View from "ol/View";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";

import { defaults as defaultControls } from "ol/control";
import { Style, Icon, Stroke, Fill, Text } from "ol/style";
import VectorSource from "ol/source/Vector";
import { Vector as VectorLayer } from "ol/layer";
import Overlay from "ol/Overlay";
import iconType from "@/utils/iconType";
const GIS_MAP = {
  city_410928000: "https://gis-server.chiaic.com/iserver/services/map-ZuoYangXianTeXiaoDiTu/rest/maps/濮阳县L11-L14_GD_TX",
};
// 无外框的乡镇边界（外框与父级因抽稀程度不同无法重合，所以用这个代替全省县界地图）
const GIS_COUNTY_MAP = {
  // 若有更多县开通大屏功能，请将其乡镇边界地图追加进来
  city_410928000: "https://gis-server.chiaic.com/iserver/services/map-HeNanGeXianXiangJieFuWu/rest/maps/濮阳县乡界", // 濮阳县
  city_410526000: "https://gis-server.chiaic.com/iserver/services/map-HeNanGeXianXiangJieFuWu/rest/maps/滑县乡界", // 滑县
  city_411121000: "https://gis-server.chiaic.com/iserver/services/map-HeNanGeXianXiangJieFuWu/rest/maps/舞阳县乡界", // 舞阳县
};
var _toolType = [64, 71, 81, 100, 101, 102];
import {
  getVehiclePointListByScreen,
  getUserPointListByScreen
} from "@/api/home";

// 合并缩放和拖动结束时可能连续触发的刷新，避免短时间重复请求
const SCREEN_POINT_REQUEST_DELAY = 100;
export default {
  name: "mapContainer",
  props: {
    // 主界面筛选数据
    commonParams: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 地图点位信息获取入参
    mapPointParmas: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 筛选聚合图标类型。0全部1车辆2机手
    filterType: {
      type: String | Number,
      default: () => {
        return 0
      }
    },
    // 车辆弹框
    detailInfoShow: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    // 机手弹框
    userDetailShow: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    const transparentCityStyle = {
      stroke: new Stroke({
        //边框
        color: "rgba(200, 200, 255, 0)",
        width: 1,
      }),
      fill: new Fill({
        //填充
        color: "rgba(200, 200, 255, .1)",
      }),
    };
    return {
      iconType,
      transparentCityStyle,
      featuresValues: [],
      stopEventFlag: false,
      layers: {
        baseLayer: null,
        provinceLayer: null,
        pointLayer: null,
        infoPointLayer: null,
        countyLayer: null,
      },
      city: "",
      // 是否已显示gis(地址名称)
      isAddressNameShow: false,
      // 是否已显示gis(图层组)
      isGroupOrLayer: false,
      // 是否已显示gis(蒙版)
      isMaskShow: false,
      // 地图中心点
      mapCenter: [115.12, 35.59],
      // 地图层级
      mapZoom: 11.0,
      // 乡镇补贴列表
      areaAllowanceList: [],
      provinces: [],
      cities: [],
      counties: [],
      towns: [],
      overlays: [], // 存储所有 Overlay
      moveCount: 0, // 记录移动次数
      levelZoom: {
        0: 4,
        1: 6.5,
        2: 9,
        3: 10.5,
        4: 12.8
      },
      lastZoomLevel: 4, // 上一次的缩放级别
      isMoving: false,
      pointSource: null,
      pointRequestTimer: null,
      pointRequestSeq: 0,
      // 分类型保留上一帧视野数据，单个接口先返回时不清空另一类图标
      pointScreenSnapshot: {
        vehicle: [],
        user: [],
      },
      // 点位缓存不设置上限，离开当前视野后只清图层、不清缓存
      pointFeatureCache: new Map(),
      // 相同图标共用 Style，避免大量点位重复创建图片对象
      pointStyleCache: new Map(),
    };
  },
  watch: {
    'commonParams.filterType': {
      handler(newValue, oldValue) {
        if(newValue != oldValue) {
          this.onMapMove();
        }
      }
    },
  },
  methods: {
    /**收割机按区域聚合农机、机手数量 */
    async resetAreaCount(areas = []) {
      let self = this;
      await self.clearOverlays();
      // 初始化空数组，用于存储分离后的各级区域数据
      const [
        provinces,
        cities,
        counties,
        towns
      ] = [[],[],[],[]];
      // 递归函数，用于遍历和分离数据
      function separateAreas(data, level = 1, parent) {
        data.forEach((item) => {
          item.latitude = Number(item.latitude);
          item.longitude = Number(item.longitude);
          const {
            areaName,
            areaId,
            userCount,
            vehicleCount,
            longitude,
            latitude,
            childrenList,
            relationVehicleCount
          } = item;
          // // 机手
          // 根据层级添加到对应的数组
          if(longitude && latitude) {
            if (level === 1) {
              if (longitude && latitude) {
                provinces.push({
                  areaName,
                  areaId,
                  userCount,
                  vehicleCount,
                  longitude,
                  latitude,
                  childrenList,
                  relationVehicleCount,
                  parent: parent
                });
                // provinceOverlays.push(overlay);
              }
            } else if (level === 2) {
              if (item.areaName !== "省直辖市") {
                if (longitude && latitude) {
                  cities.push({
                    areaName,
                    areaId,
                    userCount,
                    vehicleCount,
                    longitude,
                    latitude,
                    childrenList,
                    relationVehicleCount,
                    parent: parent
                  });
                }
                // cityOverlays.push(overlay);
              }
            } else if (level === 3) {
              if (longitude && latitude) {
                counties.push({
                  areaName,
                  areaId,
                  userCount,
                  vehicleCount,
                  longitude,
                  latitude,
                  childrenList,
                  relationVehicleCount,
                  parent: parent
                });
                // countyOverlays.push(overlay);
              }
            } else if (level === 4) {
              towns.push({
                areaName,
                areaId,
                userCount,
                vehicleCount,
                longitude,
                latitude,
                childrenList,
                relationVehicleCount,
                parent: parent
              });
            }
          }

          // 递归处理下一层
          if (childrenList && childrenList.length > 0) {
            separateAreas(childrenList, level + 1, Object.assign(item, {childrenList: null}));
          } else {
            if(level == 3) { // 县区，没有子级情况下，自己当自己子级
              separateAreas([{
                areaName,
                areaId,
                userCount,
                vehicleCount,
                longitude,
                latitude,
                relationVehicleCount,
                childrenList,
              }], level + 1, Object.assign(item, {childrenList: null}));
            }
          }
        });
      }
      // 开始分离数据
      separateAreas(areas, 1);
      
      this.provinces = provinces;
      this.cities = cities;
      this.counties = counties;
      this.towns = towns;
      // 农机和机手都未选择
      if(this.commonParams.filterType == -1) return;
      this.onMapMove();
    },
    onMapMove() {
      // 每次地图移动结束，都按当前屏幕范围重新查询点位
      this.schedulePointRequest();
      if (!this.isMoving) {
        this.updateOverlays(this.lastZoomLevel);
      }
    },
    onZoomChange(level) {
      let that = this;
      const zoom = this.map.getView().getZoom();
      function getLevelByZoom(zoom) {
        if (zoom < that.levelZoom[0]) {
          return 0;
        }
        if (zoom < that.levelZoom[1]) {
          return 1;
        }
        if (zoom < that.levelZoom[2]) {
          return 2;
        }
        if (zoom < that.levelZoom[3]) {
          return 3;
        }
        if (zoom < that.levelZoom[4]) {
          return 4;
        }
        return 5;
      }
      const levelx = getLevelByZoom(zoom);
      console.log(levelx, this.lastZoomLevel);
      // 屏幕接口返回的点位在所有层级均展示，不再由层级控制显隐
      if (this.layers.infoPointLayer) {
        this.layers.infoPointLayer.setVisible(true);
      }
      if(levelx == 5) {
        this.lastZoomLevel = levelx;
        this.clearOverlays();
        return
      }
      if (levelx !== this.lastZoomLevel) {
        console.log(levelx, this.lastZoomLevel);
        const upOrDown = levelx > this.lastZoomLevel ? "down" : "up";
        this.lastZoomLevel = levelx;
        this.updateOverlays(levelx, upOrDown);
      }
    },
    animate(overlay, upOrDown) {
      const data = overlay.get("data");
      const parent = data.parent; // 获取父级数据
      const startTime = Date.now();
      const duration = 400; // 动画时长
      let startPosition = [];
      let targetPosition = [];
      // 动画逻辑
      const animate = () => {
        const elapsed = Date.now() - startTime;
        const fraction = Math.min(elapsed / duration, 1);
        const current = [
          startPosition[0] + fraction * (targetPosition[0] - startPosition[0]),
          startPosition[1] + fraction * (targetPosition[1] - startPosition[1])
        ];
        overlay.setPosition(current);
        if (fraction < 1) {
          // this.isMoving = true;
          requestAnimationFrame(animate);
        } else {
          this.isMoving = false;
          if (upOrDown === "up") {
            this.map.removeOverlay(overlay);
            this.moveCount++;
            if (this.moveCount === this.overlays.length) {
              this.updateOverlays(this.lastZoomLevel); // 更新 Overlay
            }
          }
        }
      };
      if (upOrDown === "down" && parent) {
        // startPosition.push(parent.longitude); // 父级位置
        startPosition = [parent.longitude, parent.latitude]; // 父级位置
        targetPosition = [data.longitude, data.latitude]; // 当前点位置
        animate();
      } else if (upOrDown === "up" && parent) {
        // startPosition.push(data.longitude); // 当前点位置
        startPosition = [data.longitude, data.latitude]; // 当前点位置
        targetPosition = [parent.longitude, parent.latitude]; // 父级位置
        animate();
      }
    },
    /** 
     * 如果点在视图内，输出 true，否则输出 false。point: [x, y], viewport: { topLeft: [x1, y1], bottomRight: [x2, y2] }
     */
    isCoordinateInViewport(point, viewport) {
        const [x, y] = point;
        const { topLeft, bottomRight } = viewport;
        const [x1, y1] = topLeft;
        const [x2, y2] = bottomRight;
        return x >= x1 && x <= x2 && y >= y1 && y <= y2;
    },
    /** 获取不同情况下的overlay的html和class
     * @info 数据
     */
    getOverLayContent(info) {
      let innerHtml = '';
      let className = '';
      let offset = [35, -33];
      const userlNum = info.userCount;
      const vehiclNum = this.commonParams.isFilterContact ? info.relationVehicleCount : info.vehicleCount;
      if(this.commonParams.filterType == 1) { // 农机
        if(vehiclNum != 0) {
          className = 'vehicle-cluster_bg';
          innerHtml = `
            <div class="cluster-value vehicle-value">${ vehiclNum }</div>
          `
        }
      }
      else if(this.commonParams.filterType == 2) {// 机手
        if(userlNum != 0) {
          className = 'user-cluster_bg';
          innerHtml = `
            <div class="cluster-value">${ userlNum }</div>
          `
        }
      }
      else if(this.commonParams.filterType != -1) {// 农机和机手且非空
        // if(info.parent && info.parent.areaName == '遂平县') console.log('info :>> ', info, vehiclNum, userlNum);
        if(userlNum != 0 || vehiclNum != 0) {
          // if(info.parent && info.parent.areaName == '遂平县') console.log('info=========== :>> ', info, vehiclNum, userlNum);
          offset = [56.5, -33.5];
          className = 'vehicle-and_user-cluster__bg';
          innerHtml = `
            <div class="cluster-panel">
              <div class="cluster-value">农机:${ vehiclNum }</div>
              <div class="cluster-value">机手:${ userlNum }</div>
            </div>
          `
        }
      }
      return {
        className,
        innerHtml,
        offset
      }
    },
    /** 获取所有省市县乡镇的overlay */
    async updateOverlays(level, upOrDown) {
      if (!this || !this.map) {
        return;
      }
      let data = []
      if (level === 1) {
        data = this.provinces;
      } else if (level === 2) {
        data = this.cities;
      } else if (level === 3) {
        data = this.counties;
      } else if (level === 4) {
        data = this.towns;
      }
      if(data) {
        if (upOrDown == "up") {
          this.moveCount = 0;
          this.overlays.forEach((overlay, index) => {
            this.animate(overlay, upOrDown);
          });
        } else {
          await this.clearOverlays();
          let location = this.map.getView().calculateExtent(this.map.getSize());
          var position;
          //  过滤可视区域内Overlay
          data.forEach((item) => {
            if (upOrDown === "down" && item.parent) {
              position = [
                item.parent.longitude,
                item.parent.latitude
              ]; // 转换为投影坐标
            } else if (upOrDown === "up") {
              position = [item.longitude, item.latitude]; // 转换为投影坐标
            } else {
              position = [item.longitude, item.latitude]; // 转换为投影坐标
            }
            if(this.isCoordinateInViewport([item.longitude, item.latitude], {topLeft: [location[0], location[1]], bottomRight: [location[2], location[3]]})) {
              const element = document.createElement("div");
              const overlayInfo = this.getOverLayContent(item);
              element.className = overlayInfo.className;
              element.innerHTML = overlayInfo.innerHtml;
              const overlay = new Overlay({
                element: element,
                position: position,
                offset: [0, 10],
                stopEvent: false,
              });
              overlay.set("data", item); // 将数据存储到 Overlay 中
              overlay.setPositioning("bottom-center");
              // 绑定 click 事件
              overlay.getElement().addEventListener("click", (event) => {
                event.stopPropagation(); // 阻止事件冒泡到地图
                let addLevel = 1;
                // 点击县区，没有子级，直接跳过乡镇，到点位查看
                if(level == 3 && (!item.childrenList || item.childrenList.length<=0)) addLevel = 2;
                if(level == 4) addLevel = 0.5;
                this.map.getView().animate({
                  center: [item.longitude, item.latitude],
                  zoom: this.levelZoom[level] + addLevel,
                  duration: 400
                });
              });
              this.map.addOverlay(overlay);
              this.overlays.push(overlay);
              if (upOrDown) {
                this.animate(overlay, upOrDown);
              }
            }
          });
        }
      }
    },
    schedulePointRequest() {
      // 序号用于丢弃旧视野的迟到响应，避免覆盖最新地图数据
      const requestSeq = ++this.pointRequestSeq;
      if (this.pointRequestTimer) clearTimeout(this.pointRequestTimer);
      this.pointRequestTimer = setTimeout(() => {
        this.pointRequestTimer = null;
        this.getPointList(requestSeq);
      }, SCREEN_POINT_REQUEST_DELAY);
    },
    // 获取当前视野右上角、左下角以及实际缩放级别
    getMapViewZoom() {
      const view = this.map.getView();
      const extent = view.calculateExtent(this.map.getSize());
      return {
        topRight: `${extent[2]},${extent[3]}`,
        bottomLeft: `${extent[0]},${extent[1]}`,
        zoom: view.getZoom(),
      };
    },
    getPointList(requestSeq) {
      if (!this.map || requestSeq !== this.pointRequestSeq) return;
      const filterType = this.commonParams.filterType;
      const center = this.map.getView().getCenter();
      const params = {
        ...this.mapPointParmas,
        // 兼容后端原有参数结构，屏幕接口实际按边界和缩放级别查询
        radius: 15,
        latitude: center[1],
        longitude: center[0],
        ...this.getMapViewZoom(),
      };

      // 未选择农机和机手时只清空当前图层，历史缓存继续保留
      if (filterType == -1) {
        this.pointScreenSnapshot.vehicle = [];
        this.pointScreenSnapshot.user = [];
        this.setVehiclePoints([], 'all');
        return;
      }

      const commitPoints = (type, points) => {
        if (!this.map || requestSeq !== this.pointRequestSeq) return;
        // 只替换本次已返回的类型，另一类型沿用上一帧，避免异步返回造成闪烁
        this.pointScreenSnapshot[type] = Array.isArray(points) ? points : [];
        const visiblePoints = filterType == 1
          ? this.pointScreenSnapshot.vehicle
          : filterType == 2
            ? this.pointScreenSnapshot.user
            : this.pointScreenSnapshot.vehicle.concat(this.pointScreenSnapshot.user);
        // 使用已返回的新数据和另一类型的上一帧数据同步，移动后图标连续展示
        this.setVehiclePoints(visiblePoints, 'all');
      };
      const handleError = (type, error) => {
        console.error(`get${type == 'vehicle' ? 'Vehicle' : 'User'}PointListByScreen.error::`, error);
        commitPoints(type, []);
      };

      // 两类接口独立返回、独立渲染，避免一个慢请求阻塞另一类图标显示
      if (filterType == 0 || filterType == 1) {
        getVehiclePointListByScreen(params)
          .then(points => commitPoints('vehicle', points))
          .catch(error => handleError('vehicle', error));
      }
      if (filterType == 0 || filterType == 2) {
        getUserPointListByScreen(params)
          .then(points => commitPoints('user', points))
          .catch(error => handleError('user', error));
      }
    },
    // 优先使用业务主键生成稳定缓存键，无主键时使用坐标兜底
    getPointCacheKey(point, pointType, index) {
      const idList = pointType == 'user'
        ? [point.userId, point.id]
        : [point.vehicleId, point.facilityId, point.drcId, point.terminalId, point.id];
      const pointId = idList.find(id => id !== undefined && id !== null && id !== '');
      return pointId !== undefined
        ? `${pointType}:${pointId}`
        : `${pointType}:${point.longitude}:${point.latitude}:${index}`;
    },
    // 图标样式按业务状态缓存，相同样式只创建一次
    getVehicleOrUserPointStyle(point, pointType) {
      if (!(this.pointStyleCache instanceof Map)) this.pointStyleCache = new Map();
      if (pointType == 'user') {
        const styleKey = 'user';
        if (!this.pointStyleCache.has(styleKey)) {
          this.pointStyleCache.set(styleKey, new Style({
            image: new Icon({
              anchor: [1, 1],
              scale: 0.21,
              anchorXUnits: 'fraction',
              anchorYUnits: 'pixels',
              src: require('@/assets/img/icon_map/userIcon.png'),
            }),
          }));
        }
        return { styleKey, style: this.pointStyleCache.get(styleKey) };
      }

      const isOnline = point.isOnline ? 1 : 0;
      const jobTypeCode = point.jobTypeCode == 188 ? 5 : point.jobTypeCode;
      const terminalTypeStr = point.terminalTypeStr || '';
      const styleKey = `vehicle:${jobTypeCode || 'default'}:${isOnline}:${terminalTypeStr}`;
      if (this.pointStyleCache.has(styleKey)) {
        return { styleKey, style: this.pointStyleCache.get(styleKey) };
      }

      let url;
      try {
        let icon = `icon_map_${jobTypeCode}_${isOnline ? 'on' : 'off'}_${terminalTypeStr}`;
        if (!jobTypeCode || jobTypeCode === 'default' || [0, 255].includes(jobTypeCode)) {
          url = isOnline
            ? require('@/assets/img/icon_map/icon_map_0_on.png')
            : require('@/assets/img/icon_map/icon_map_0_off.png');
        } else if (_toolType.includes(jobTypeCode)) {
          icon = `icon_map_${jobTypeCode}_${isOnline ? 'on' : 'off'}`;
          url = require(`@/assets/img/icon_map/${icon}.png`);
        } else {
          url = require(`@/assets/img/icon_map/${icon}.png`);
        }
      } catch (error) {
        try {
          url = require(`@/assets/img/icon_map/icon_map_0_${isOnline ? 'on' : 'off'}_${terminalTypeStr}.png`);
        } catch (error) {
          url = isOnline
            ? require('@/assets/img/icon_map/icon_map_0_on.png')
            : require('@/assets/img/icon_map/icon_map_0_off.png');
        }
      }
      const style = new Style({
        image: new Icon({
          anchor: [1, 1],
          scale: 0.2,
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          src: url,
        }),
      });
      this.pointStyleCache.set(styleKey, style);
      return { styleKey, style };
    },
    async clearOverlays() {
      this.overlays.forEach((overlay) => {
        this.map.removeOverlay(overlay);
      });
      this.overlays = [];
    },
    /** 添加乡镇指示标识 */
    setTownship(arr = []) {
      this.areaAllowanceList = arr;
      if(this.townshipLayer) this.map.removeLayer(this.townshipLayer);
      var source = new VectorSource();
      arr.map(v=>{
        var iconFeature = new Feature({
          geometry: new Point([v.longitude, v.latitude]),
          feature_type: '乡镇统计点',
          ...v
        });
        source.addFeature(iconFeature);
      });
      this.townshipLayer = new VectorLayer({
        zIndex:1000,
        source: source,
        style: function (feature, resolution) {
          // 乡镇图标
          return new Style({
            zIndex: 1,
            image: new Icon({
              scale: 0.5,
              anchorOrigin: 'bottom-left',
              offsetY: 0,  // 偏移
              anchorXUnits: "fraction",
              anchorYUnits: "pixels",
              src:  require("../../../assets/images/common/icon_map_xz.png"),
            }),
          });
        }
      });
      this.map.addLayer(this.townshipLayer);
    },
    initBaseLayer() {
      var url = '';
      this.map = new OlMap({
        target: "map",
        layers: [
          new TileLayer({
            source: new XYZ({
              // url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?x={x}&y={y}&z={z}&lang=zh_cn&size=1&scl=1&style=6'
              url: 'https://t{0-7}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TileCol={x}&TileRow={y}&TileMatrix={z}&tk=1d109683f4d84198e37a38c442d68311'
            }),
            isGroup: true,
            name: '高德图路网'
          }),
          new TileLayer({
            zIndex:10,
            source: new TileSuperMapRest({
              url: this.$utils.formatUrl('https://gis-server.chiaic.com/iserver/services/map-QuanGuoXingZhengQuHuaShuJu/rest/maps/全国矢量数据'),
              cacheEnabled: false,

            }),
            isGroup: true,
            name: "全国省矢量",
            type: "baseLyer",
          }),
          // new TileLayer({
          //   zIndex:11,
          //   source: new TileSuperMapRest({
          //     url: 'https://gis-server.chiaic.com/iserver/services/map-HeNanShengNeiXiangJie/rest/maps/河南省内乡界',
          //     cacheEnabled: false,
          //   }),
          //   isGroup: true,
          //   name: "县的行政区划（乡镇界线）",
          //   type: "baseLyer",
          // }),
          new TileLayer({
            zIndex:0,
            source: new TileSuperMapRest({
              url: this.$utils.formatUrl('https://gis-server.chiaic.com/iserver/services/map-QuanGuoXingZhengQuHuaShuJu/rest/maps/全国省界'),
              cacheEnabled: false,
            }),
            isGroup: true,
            name: "全国省界",
            type: "baseLyer",
          })
        ],
        controls: defaultControls({
          attribution: false,
        }),
        view: new View({
          center: this.mapCenter,
          zoom: this.mapZoom,
          projection: "EPSG:4326",
          maxZoom: 14,
          minZoom: 6,
        }),
      });
      // 点位图层只创建一次，后续移动地图时仅增量更新 Feature
      this.pointSource = new VectorSource();
      this.layers.infoPointLayer = new VectorLayer({
        zIndex: 15,
        source: this.pointSource,
      });
      this.map.addLayer(this.layers.infoPointLayer);
      this.layers.baseLayer = new TileLayer({
        source: new TileSuperMapRest({
          url,
          cacheEnabled: false,
        }),
        isGroup: true,
        zIndex: 0,
        name: "高清影像图",
        type: "baseLyer",
      });
      this.map.addLayer(this.layers.baseLayer);
      this.layers.countyLayer = new TileLayer({
        source: new TileSuperMapRest({
          url,
          cacheEnabled: false,
        }),
        isGroup: true,
        zIndex: 11,
        name: "乡镇边界",
        type: "baseLyer",
      });
      this.map.addLayer(this.layers.countyLayer);
      this.map.on("singleclick", (e) => {
        var pixel = this.map.getEventPixel(e.originalEvent);
        var currentFeature = this.map.forEachFeatureAtPixel(
          pixel,
          function (feature, layer) {
            return feature;
          }
        );
        if (!currentFeature) {
          this.$emit('update:detailInfoShow', false);
          this.$emit('update:userDetailShow', false);
        }
        console.log('currentFeature :>> ', currentFeature);
        // 机手
        if (currentFeature.values_._userId) {
          this.$emit("userPointClick", currentFeature.values_);
          return;
        }
        if (currentFeature.values_._vehicleId) {
          console.log('currentFeature>>',currentFeature.values_);
          this.$emit("vehiclePointClick", currentFeature.values_);
        } else {
          this.resetMapView();
        }
      });
      // 监听hover
      this.map.on("pointermove", (e) => {
        var pixel = this.map.getEventPixel(e.originalEvent);
        var currentFeature = this.map.forEachFeatureAtPixel(
          pixel,
          function (feature, layer) {
            return feature;
          }
        );
        if(currentFeature && currentFeature.values_ && currentFeature.values_.feature_type == '乡镇统计点') {
          let info = {
            x: e.originalEvent.x,
            y: e.originalEvent.y,
            ...currentFeature.values_
          }
          this.$emit("townshipPoint", true, info);
        } else {
          this.$emit("townshipPoint", false);
        }
      })
      this.map.getView().on("change:resolution", this.onZoomChange);
      this.map.on("moveend", this.onMapMove);
      this.checkZoom(this.map.getView().getZoom());
      this.map.getView().on('change:resolution', () => {
        this.checkZoom(this.map.getView().getZoom());
      });
    },
    /** 重置试图层级、中心点 */
    resetMapView() {
      if(this.map.getView().getZoom() != this.mapZoom || JSON.stringify(this.map.getView().getCenter()) != JSON.stringify(this.mapCenter) ) {
        // 重置层级
        this.map.getView().setZoom(this.mapZoom);
        // 重置中心
        this.map.getView().setCenter(this.mapCenter);
      }
    },
    async initProvinceLayer() {
      //行政区划边界图层
      this.layers.provinceLayer = new VectorLayer({
        renderMode: "vector",
        source: new VectorSource(),
        zIndex: 1,
        rotation: 2,
      });
      this.map.addLayer(this.layers.provinceLayer);

      //点位图层
      this.layers.pointLayer = new VectorLayer({
        renderMode: "vector",
        source: new VectorSource(),
        style: this.getPointStyle,
        zIndex: 100,
      });
      this.map.addLayer(this.layers.pointLayer);
    },
    addProvince(city) {
      this.city = city;
      let style = null;
      if (this.layers.provinceLayer.getSource()) {
        this.layers.provinceLayer.getSource().clear();
      }
      // 舞阳加载gis图片
      console.log('GIS_MAP_URL', GIS_MAP[city]);
      if (GIS_MAP[city]) {
      this.layers.baseLayer.setSource(
        new TileSuperMapRest({
          url: this.$utils.formatUrl(GIS_MAP[city]),
          cacheEnabled: false,
        })
      );
      } else {
        console.log('%c缺少GIS图片', 'color:#C00', GIS_MAP[city], city, GIS_MAP);
      }
      style = this.transparentCityStyle;
      // 加载乡镇边界
      if (this.layers.countyLayer.getSource()) {
        this.layers.countyLayer.getSource().clear();
      }
      if (GIS_COUNTY_MAP[city]) {
        console.log('%c加载乡镇边界地图', 'color:#CC0', GIS_COUNTY_MAP[city], city, GIS_COUNTY_MAP);
        this.layers.countyLayer.setSource(
          new TileSuperMapRest({
            url: this.$utils.formatUrl(GIS_COUNTY_MAP[city]),
            cacheEnabled: false,
          })
        );
      } else {
        console.log('%c缺少乡镇边界地图', 'color:#C00', GIS_COUNTY_MAP[city], city, GIS_COUNTY_MAP);
      }
    },
    /** 地图层级变更 */
    checkZoom(zoom) {
      if(zoom<=10.9 || zoom>=11.1) { // 乡镇统计显隐处理
        if(!this.removeTownship) {
          if(this.townshipLayer) { // 避免重复清除
            this.removeTownship = true;
            this.map.removeLayer(this.townshipLayer);
          }
        }
      } else {
        if(this.removeTownship) { // 避免重复加载
          this.removeTownship = false;
          this.setTownship(this.areaAllowanceList);
        }
      } 
      let this_ = this;
      if(this.isGroupOrLayer == zoom>=10.6 && this.isMaskShow == zoom>=7 && this.isAddressNameShow == zoom<11.4) return; // 限制不管是隐藏地址名称还是显示，都只执行一次
      this.isGroupOrLayer = zoom>10.6 ? true: false;
      this.isMaskShow = zoom>7 ? true: false;
      this.isAddressNameShow = zoom>=11.4 ? false: true;
      var address = new LayerStatus({
          layerName: "濮阳@濮阳县_TX",
          isVisible: zoom>=11.4 ? false: true // 控制显示隐藏地址名称
      });
      var ortherAddressNameGroup = new LayerStatus({
          layerName: "LayerGroup",
          isVisible: zoom>10.6 ? true: false // 控制显示隐藏地址名称
      });
      var layerStatus = new LayerStatus({
          layerName: "蒙版@濮阳县_TX",
          isVisible: zoom>7 ? true: false // 控制显示隐藏地址名称
      });
      var setLayerStatusParameters = new SetLayerStatusParameters({
          layerStatusList: [ortherAddressNameGroup, layerStatus, address]
      });
      new LayerInfoService(this.$utils.formatUrl("https://gis-server.chiaic.com/iserver/services/map-ZuoYangXianTeXiaoDiTu/rest/maps/濮阳县L11-L14_GD_TX")).setLayerStatus(setLayerStatusParameters, function (e) {
          // 图层服务异常时 result 可能为空，直接返回避免页面产生未捕获报错
          if (!e || !e.result || !e.result.newResourceID) {
            console.warn('地图图层状态更新失败::', e);
            return;
          }
          this_.map.removeLayer(this_.addressNameTileLayer);
          var tempLayerID = e.result.newResourceID;
          this_.addressNameTileLayer = new TileLayer({
              source: new TileSuperMapRest({
                  url: this_.$utils.formatUrl("https://gis-server.chiaic.com/iserver/services/map-ZuoYangXianTeXiaoDiTu/rest/maps/濮阳县L11-L14_GD_TX"),
                  cacheEnabled: false,
                  layersID: tempLayerID
              }),
              projection: 'EPSG:4326'
          });
          this_.map.addLayer(this_.addressNameTileLayer);
      });
    },
    /** 增量同步农机、机手图标 */
    setVehiclePoints(arr, syncType = 'all') {
      if (!this.map || !this.pointSource) return;
      // 兼容开发热更新期间遗留的旧缓存对象
      if (!(this.pointFeatureCache instanceof Map)) this.pointFeatureCache = new Map();
      const pointList = Array.isArray(arr) ? arr : [];
      console.log('本次地图点位数量::', pointList.length);

      const sourceFeatures = this.pointSource.getFeatures();
      const visibleFeatureMap = new Map();
      sourceFeatures.forEach(feature => visibleFeatureMap.set(feature.getId(), feature));
      const nextPointKeys = new Set();
      const featuresToAdd = [];

      pointList.forEach((point, index) => {
        if (!point) return;
        const longitude = Number(point.longitude);
        const latitude = Number(point.latitude);
        if (
          !Number.isFinite(longitude) ||
          !Number.isFinite(latitude) ||
          longitude < -180 || longitude > 180 ||
          latitude < -90 || latitude > 90
        ) return;

        const pointType = syncType == 'all'
          ? point.personOrVehicle == 'user' || point.userId != null ? 'user' : 'vehicle'
          : syncType;
        const pointKey = this.getPointCacheKey(point, pointType, index);
        if (nextPointKeys.has(pointKey)) return;
        nextPointKeys.add(pointKey);

        let feature = visibleFeatureMap.get(pointKey) || this.pointFeatureCache.get(pointKey);
        const coordinates = [longitude, latitude];
        const styleData = this.getVehicleOrUserPointStyle(point, pointType);
        const featureData = pointType == 'user'
          ? { _pointType: 'user', _userId: point.userId != null ? point.userId : point.id }
          : {
              _pointType: 'vehicle',
              _jobTypeCode: point.jobTypeCode || 'default',
              _isOnline: point.isOnline || 0,
              _drcId: point.drcId,
              _vehicleId: point.vehicleId != null ? point.vehicleId : point.id,
              _terminalType: point.terminalType,
              _terminalTypeStr: point.terminalTypeStr,
            };

        if (!feature) {
          feature = new Feature({ geometry: new Point(coordinates), ...featureData });
          feature.setId(pointKey);
          feature.setStyle(styleData.style);
          feature.set('_styleKey', styleData.styleKey, true);
        } else {
          const oldCoordinates = feature.getGeometry().getCoordinates();
          if (oldCoordinates[0] !== longitude || oldCoordinates[1] !== latitude) {
            feature.getGeometry().setCoordinates(coordinates);
          }
          feature.setProperties(featureData, true);
          if (feature.get('_styleKey') !== styleData.styleKey) {
            feature.setStyle(styleData.style);
            feature.set('_styleKey', styleData.styleKey, true);
          }
        }

        this.pointFeatureCache.set(pointKey, feature);
        if (!visibleFeatureMap.has(pointKey)) featuresToAdd.push(feature);
      });

      // 批量加入新增点位，复用已有 Feature，避免整层重建造成闪烁和卡顿
      if (featuresToAdd.length) this.pointSource.addFeatures(featuresToAdd);
      sourceFeatures.forEach(feature => {
        const featureType = feature.get('_pointType');
        if ((syncType == 'all' || syncType == featureType) && !nextPointKeys.has(feature.getId())) {
          this.pointSource.removeFeature(feature);
        }
      });

      this.layers.infoPointLayer.setVisible(true);
      this.map.render();
      // 缓存不设置数量上限，打印当前累计缓存数量便于观察复用情况
      console.log('地图点位缓存数量::', this.pointFeatureCache.size);
    }
  },
  mounted() {
    this.initBaseLayer();
    this.initProvinceLayer();
    this.addProvince();
  },
  beforeDestroy() {
    this.pointRequestSeq += 1;
    if (this.pointRequestTimer) {
      clearTimeout(this.pointRequestTimer);
      this.pointRequestTimer = null;
    }
    if (this.map) {
      this.map.setTarget(null);
      this.map = null;
    }
    if (this.pointFeatureCache instanceof Map) this.pointFeatureCache.clear();
    if (this.pointStyleCache instanceof Map) this.pointStyleCache.clear();
  },
};
</script>
<style lang="scss">
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
.mapContainer {
  float: right;
  width: 100%;
  height: 100%;
  position: relative;
}
.ol-zoom.ol-unselectable.ol-control {
  display: none;
}
.map {
  width: 100%;
  height: 100%;
}
.big .big_round {
  width: vw(380) !important;
  height: vw(380) !important;
}
.big .small_round {
  width: vw(220) !important;
  height: vw(220) !important;
  .center_icon {
    width: vw(60) !important;
    height: vw(60) !important;
  }
}
.big .type_item {
  transform-origin: vw(-10) vw(180) !important;
}
.big_round {
  width: vw(150);
  height: vw(150);
  background: url("../../../assets/img/home/round_big.png") center no-repeat;
  //background: red;
  border-radius: 100%;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  box-shadow: 10px 10px 10px 10px rgba(0, 0, 0, 0.3);
  .small_round {
    width: vw(74);
    height: vw(74);
    background: url("../../../assets/img/home/round.png") center no-repeat;
    // background: black;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: 100% 100%;
    box-shadow: 10px 10px 10px 10px rgba(0, 0, 0, 0.3);
    .center_icon {
      width: vw(46);
      height: vw(46);
    }
  }
  .type_item {
    width: vw(25);
    height: vw(25);
    border-radius: 100%;
    /* background-image: url("./icons/icon1.png"); */
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    color: #000;
    transform-origin: vw(-10) vw(65);
    top: 0;
    position: absolute;
    left: 50%;
    margin: vw(10) 0 0 vw(10);
  }
  .type_item .img {
    width: vw(25);
    height: vw(25);
  }
  .type_item .detailName {
    color: #fff !important;
    right: 0 !important;
    top: 0 !important;
    display: none;
    z-index: 10;
  }
  .type_item:hover .detailName {
    display: block !important;
  }
  .type_item .detail {
    padding: vw(5) vh(10);
    background: rgba(9, 47, 15, 1);
    border: 1px solid rgba(15, 102, 57, 1);
    color: rgba(255, 255, 154, 1);
    position: absolute;
    right: -370%;
    top: -190%;
    font-size: vh(1);
    box-shadow: 10px 10px 10px 10px rgba(0, 0, 0, 0.3);
    .stat {
      position: relative;

      display: flex;
      justify-content: center;
      align-items: center;
    }
    .dot {
      width: vw(5);
      height: vw(5);
      background: #0dffa9;
      border-radius: 100%;
      margin-right: vw(10);
    }
  }
  /*   .type_item:first-child {
    transform-origin: 0 0;
  } */
}
.ol-rotate {
  display: none;
}
</style>
